import { useGridApiContext } from "@mui/x-data-grid";
import { EditableSelectCustomOnChange } from "ui-components/EditableInput2";

export const putawayColumns = (zoneOptions, zoneObj) => {
  const Cell = ({ params }) => {
    //setZoneID(params.row.toZone)
    const apiRef = useGridApiContext();
    const { id, field, value } = params;

    const onChange = (e, option) => {
      apiRef.current.setEditCellValue({
        id,
        field,
        value: option,
      });
    };

    return (
      <EditableSelectCustomOnChange
        disableClearable={true}
        getValue={() => value ?? null}
        onChange={onChange}
        options={zoneOptions}
        //style={{ width: "100% !important" }}
      />
    );
  };
  const LocationCell = ({ params }) => {
    //console.log(params.row.toZone)
    const apiRef = useGridApiContext();
    const { id, field, value, row } = params;

    const onChange = (e, option) => {
      apiRef.current.setEditCellValue({
        id,
        field,
        value: option,
      });
    };

    return (
      <EditableSelectCustomOnChange
        disableClearable={true}
        getValue={() => value ?? null}
        onChange={onChange}
        options={zoneObj[row.toZone] ?? []}
        //style={{ width: "100%" }}
      />
    );
  };
  return [
    {
      field: "lineNo",
      headerName: "Line No",
      sortable: false,
      align: "right",
      width: 80,
    },
    {
      field: "skuCode",
      headerName: "SKU Code",
      sortable: false,
      align: "left",
      width: 220,
    },
    {
      field: "packType",
      headerName: "Pack Type",
      sortable: false,
      align: "left",
    },
    {
      field: "oln",
      headerName: "OLN",
      sortable: false,
      align: "left",
      width: 120,
    },
    {
      field: "mln",
      headerName: "MLN",
      sortable: false,
      align: "left",
      width: 120,
    },
    {
      field: "expiryDate",
      headerName: "Expiry Date",
      sortable: false,
      align: "left",
      width: 120,
    },
    {
      field: "cartonID",
      headerName: "Carton ID",
      sortable: false,
      align: "left",
      width: 120,
    },
    {
      field: "palletNbr",
      headerName: "Pallet Nbr",
      sortable: false,
      align: "left",
      width: 120,
    },
    {
      field: "fromZone",
      headerName: "From Zone",
      sortable: false,
      align: "left",
    },
    {
      field: "fromLocation",
      headerName: "From Location",
      sortable: false,
      align: "left",
    },
    {
      field: "toZone",
      headerName: "To Zone",
      sortable: false,
      align: "left",
      width: 200,
      editable: true,
      headerClassName: "custom-editable-header",
      renderEditCell: (params) => <Cell params={params} />,
    },
    {
      field: "toLocation",
      headerName: "To Location",
      sortable: false,
      align: "left",
      width: 200,
      editable: true,
      headerClassName: "custom-editable-header",
      renderEditCell: (params) => <LocationCell params={params} />,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      sortable: false,
      align: "right",
    },
    {
      field: "baseUOM",
      headerName: "Base UOM",
      sortable: false,
      align: "left",
    },
    {
      field: "computation",
      headerName: "Computation",
      sortable: false,
      align: "left",
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      align: "left",
    },
  ];
};

export const putawayCancelOrderColumns = (zoneOptions, zoneObj, setEditing) => {
  const Cell = ({ params }) => {
    //setZoneID(params.row.toZone)
    const apiRef = useGridApiContext();
    const { id, field, value } = params;

    const onChange = (e, option) => {
      setEditing(true);
      apiRef.current.setEditCellValue({
        id,
        field,
        value: option,
      });
    };

    return (
      <EditableSelectCustomOnChange
        disableClearable={true}
        getValue={() => value ?? null}
        onChange={onChange}
        options={zoneOptions}
      />
    );
  };
  const LocationCell = ({ params }) => {
    //console.log(params.row.toZone)
    const apiRef = useGridApiContext();
    const { id, field, value, row } = params;

    const onChange = (e, option) => {
      setEditing(true);
      apiRef.current.setEditCellValue({
        id,
        field,
        value: option,
      });
    };

    return (
      <EditableSelectCustomOnChange
        disableClearable={true}
        getValue={() => value ?? null}
        onChange={onChange}
        options={zoneObj[row.to_zone] ?? []}
      />
    );
  };
  return [
    {
      field: "sku_code",
      headerName: "SKU Code",
      sortable: false,
      align: "left",
      flex: 1,
      //width: 220,
    },
    {
      field: "order_quantity",
      headerName: "Order Qty",
      sortable: false,
      align: "right",
      width: 120,
    },
    {
      field: "mln",
      headerName: "MLN",
      sortable: false,
      align: "left",
      //flex:1,
      width: 120,
    },
    {
      field: "expiry_date",
      headerName: "Expiry Date",
      sortable: false,
      align: "left",
      //flex:1
      width: 150,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      sortable: false,
      align: "right",
      editable: true,
      type: "number",
      headerClassName: "custom-editable-header",
      width: 120,
    },
    {
      field: "to_zone",
      headerName: "To Zone",
      sortable: false,
      align: "left",
      editable: true,
      headerClassName: "custom-editable-header",
      renderEditCell: (params) => <Cell params={params} />,
      flex: 1,
    },
    {
      field: "to_location",
      headerName: "To Location",
      sortable: false,
      align: "left",
      //width: 200,
      editable: true,
      headerClassName: "custom-editable-header",
      renderEditCell: (params) => <LocationCell params={params} />,
      flex: 1,
    },
    {
      field: "carton_id",
      headerName: "Carton ID",
      sortable: false,
      align: "left",
      editable: true,
      type: "text",
      headerClassName: "custom-editable-header",
      flex: 1,
      //width: 120,
    },
  ];
};
